export default {"src":"/_next/static/media/be-a-specialist.9bfda3dd.svg","height":120,"width":120,"blurWidth":0,"blurHeight":0};